import { filename } from "@tsmono/util";

const kLogFilePattern =
  /^(\d{4}-\d{2}-\d{2}T\d{2}-\d{2}-\d{2}[-+]\d{2}-\d{2})_(.+)_([0-9A-Za-z]+)\.(eval|json)$/;

export interface ParsedLogFileName {
  timestamp?: Date;
  name: string;
  taskId?: string;
  extension: "eval" | "json";
}

/** Log file names carry a filesystem-safe ISO timestamp (colons replaced
 *  with dashes: `2026-07-04T19-37-16-00-00`); restore the colons so the
 *  Date parser accepts it. */
const parseFileNameTimestamp = (raw: string): Date | undefined => {
  const iso = raw.replace(
    /T(\d{2})-(\d{2})-(\d{2})([-+])(\d{2})-(\d{2})$/,
    "T$1:$2:$3$4$5:$6"
  );
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

export const parseLogFileName = (logFileName: string): ParsedLogFileName => {
  const match = logFileName.match(kLogFilePattern);
  if (!match) {
    // read the extension
    return {
      timestamp: undefined,
      name: filename(logFileName),
      taskId: undefined,
      extension: logFileName.endsWith(".eval") ? "eval" : "json",
    };
  }

  return {
    // @ts-expect-error pre-existing noUncheckedIndexedAccess violation (TODO: narrow when touched)
    timestamp: parseFileNameTimestamp(match[1]),
    // @ts-expect-error pre-existing noUncheckedIndexedAccess violation (TODO: narrow when touched)
    name: match[2],
    taskId: match[3],
    extension: match[4] === "json" ? "json" : "eval",
  };
};
